<template>
  <div>
    <treeselect
      :match-keys="[labelField]"
      :class="[
        { 'option-side': isOptionSide, 'selected-side': isSelectedSide },
        classes,
        'treeselect',
      ]"
      :backspace-removes="backspaceRemove"
      v-bind="$attrs"
      :clearable="clearable"
      v-on="$listeners"
    >
      <template :class="labelClassName" v-slot:value-label="{ node }">
        {{ node.raw[labelField] }}
      </template>
      <template
        v-slot:option-label="{
          node,
          shouldShowCount,
          count,
          labelClassName,
          countClassName,
        }"
      >
        <label :class="labelClassName">
          <div
            v-if="node.raw.customStyle"
            :style="
              node.raw.customStyle +
              (node.raw.id === value ? 'color: #366193;' : '')
            "
          >
            {{ node.raw[labelField] }}
          </div>
          <div v-else>
            {{ node.raw[labelField] }}
          </div>
          <span v-if="shouldShowCount" :class="countClassName">
            ({{ count }})
          </span>
          <div
            v-if="node.raw[descriptionField]"
            class="vue-treeselect__description"
          >
            <slot name="custom-option-desc" v-bind:node="node">
              <small class="text-muted">
                {{ node.raw[descriptionField] }}
              </small>
            </slot>
          </div>
        </label>
      </template>
    </treeselect>
    <slot name="validation">
      <validation-message :validate="validation" />
    </slot>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import ValidationMessage from '~shared/components/ValidationMessage';

export default {
  components: {
    ValidationMessage,
    Treeselect,
  },
  props: {
    classes: {
      type: String,
      required: false,
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
    labelField: {
      type: String,
      default: 'label',
    },
    descriptionField: {
      type: String,
      default: 'description',
    },
    isOptionSide: {
      type: Boolean,
      default: false,
    },
    isSelectedSide: {
      type: Boolean,
      default: false,
    },
    backspaceRemove: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.treeselect::v-deep {
  .vue-treeselect__control {
    border-color: #ced4da;
  }

  .vue-treeselect__control-arrow {
    color: #999;
  }

  .vue-treeselect:not(.vue-treeselect--disabled)
    .vue-treeselect__control-arrow-container:hover
    .vue-treeselect__control-arrow {
    color: #999;
  }

  .vue-treeselect--disabled .vue-treeselect__control {
    background-color: #e9ecef;
  }

  .vue-treeselect__multi-value-item {
    background-color: #f0f3f5;
    color: #5c6873;
    font-weight: 600;
  }

  .vue-treeselect__value-container {
    font-size: 0.76562rem;
  }

  .vue-treeselect__value-remove {
    color: #5c6873;
  }

  .vue-treeselect__placeholder {
    font-size: 0.76562rem;
    color: #5c6873;
  }

  .vue-treeselect__label {
    font-size: 0.76562rem;
    white-space: normal;
    line-height: 1.5em;
    padding: 8px 0px 8px 5px;
  }

  .vue-treeselect__control {
    font-size: 0.76562rem;
    height: calc(1.725em + 0.75rem);
  }

  .vue-treeselect--single .vue-treeselect__menu {
    line-height: 240%;
  }

  .vue-treeselect--single .vue-treeselect__option--selected,
  .vue-treeselect--single
    .vue-treeselect__option--selected.vue-treeselect__option--highlight {
    background-color: #4d92e3 !important;
    color: #ffffff !important;
  }

  .vue-treeselect--single .vue-treeselect__option--selected .text-muted {
    color: #ffffff !important;
  }

  .vue-treeselect--single .vue-treeselect__description {
    margin-top: -5px;
    padding-bottom: 8px;
    line-height: 1.5em;
    white-space: normal;
  }

  .vue-treeselect--multi .vue-treeselect__description {
    margin-top: -10px;
  }

  .vue-treeselect__multi-value-label {
    white-space: normal;
  }
}

::v-deep {
  .option-side .vue-treeselect__menu,
  .selected-side .vue-treeselect__menu {
    height: 300px;
  }

  .option-side .vue-treeselect__limit-tip-text {
    padding-top: 0px;
    display: none;
  }

  .option-side .vue-treeselect__placeholder {
    display: none;
  }

  .option-side .vue-treeselect__input-container::before {
    content: 'Search';
    color: #bdbdbd;
    font-size: 0.76562rem;
    font-weight: bold;
    padding-right: 5px;
  }

  .option-side .vue-treeselect__input-container {
    vertical-align: middle !important;
    padding-left: 5px !important;
  }

  .option-side .vue-treeselect__input {
    padding-top: 0;
    padding-bottom: 0;
    line-height: inherit;
  }

  .option-side .vue-treeselect-helper-zoom-effect-off {
    display: none;
  }

  .selected-side .vue-treeselect__label-container:hover,
  .selected-side .vue-treeselect__checkbox--indeterminate,
  .selected-side .vue-treeselect__checkbox--unchecked,
  .selected-side .vue-treeselect__checkbox--checked {
    background: none !important;
    border: none !important;
  }

  .selected-side .vue-treeselect__minus-mark,
  .selected-side .vue-treeselect__check-mark {
    background-image: url('../../assets/icons/times.svg');
    color: red;
  }
}
#iab-category-group .vue-treeselect__label > div {
  padding-left: 10px;
}
</style>
